import { ClusterType } from '../clustering.types';
import { TagProps } from '@cdl/heartbeat-react';

export const useClassificationColor = () => {
  return (type: ClusterType): TagProps['colorScheme'] => {
    switch (type) {
      case 'PAC':
        return 'yellow';
      case 'PVC':
        return 'blue';
      case 'Sinus':
        return 'green';
      default:
        return 'grey';
    }
  };
};
